module.exports = __webpack_public_path__ + "img/about02.f68c2f6b.jpg";